import RoleForm from '../../RoleForm'

import useUpdateRoleHandler from '../../../effects/edit-role'
import { Role } from 'graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type EditRoleModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	role: Role,
	onDeleteClick: () => void,
}

export default function EditRoleModal( { onCancel, onSuccess, role, onDeleteClick }: EditRoleModalProps ) {
	const updateRole = useUpdateRoleHandler()

	const handleSubmit = async( name: string, spendingLimit: string ) => {
		heapEvent( 'Inventory - Edit Role Modal - Click - Submit', {} )
		const sl = spendingLimit === '' ? undefined : parseFloat( spendingLimit )
		return await updateRole( role.id, name, sl )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Edit Role Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<RoleForm
			onCancel={handleCancel}
			onSuccess={onSuccess}
			role={role}
			onSubmit={handleSubmit}
			onDeleteClick={onDeleteClick}
		/>
	)
}
